import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface NavBarContextType {
	selectedOption: string | null;
	setSelectedOption: React.Dispatch<React.SetStateAction<string | null>>;
}

// Crear el contexto
const NavBarContext = createContext<NavBarContextType | undefined>(undefined);

interface NavBarProviderProps {
	children: ReactNode;
}

// Proveedor del contexto
export const NavBarProvider: React.FC<NavBarProviderProps> = ({ children }) => {
	const [selectedOption, setSelectedOption] = useState<string | null>('Tareas'); // Opción inicial

	// ✅ OPTIMIZACIÓN: Memorizar el valor del contexto para evitar re-renderizaciones innecesarias
	// setSelectedOption es estable (no cambia), solo necesitamos selectedOption en las dependencias
	const value = useMemo<NavBarContextType>(
		() => ({
			selectedOption,
			setSelectedOption
		}),
		[selectedOption] // ✅ Solo selectedOption, setSelectedOption es estable
	);

	return (
		<NavBarContext.Provider value={value}>{children}</NavBarContext.Provider>
	);
};

// Hook para usar el contexto
export const useNavBar = (): NavBarContextType => {
	const context = useContext(NavBarContext);
	if (!context) {
		throw new Error('useNavBar must be used within a NavBarProvider');
	}
	return context;
};
